import type { HistoricalImportBatchDetail } from '@tark/shared/types';

export function downloadPreparation(contents: string, filename: string, type = 'text/plain;charset=utf-8') {
  const href = URL.createObjectURL(new Blob([contents], {type}));
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export function repairReport(detail: HistoricalImportBatchDetail): string {
  const issues = detail.rows.flatMap(row => row.issues?.length ? row.issues : row.reasonCodes.map(code => ({
    row: row.rowNumber, matchKey: row.sourceMatchId, field: 'match', code, expected: 'valid match data',
    action: 'Review this match in TARK; confirm unknown values with the owner.',
  })));
  return 'Fix the attached CSV using these TARK validation results. Keep stable session/match references and all other verified data unchanged. Never invent scores, players, winners or times. Player account mapping is completed inside TARK. Exact duplicates are skipped; retain them in your reconciliation list. Ask me about conflicts or missing facts.\n\n'
    + JSON.stringify({schemaVersion: detail.summary.schemaVersion || 'Legacy CSV — use the current preparation kit when reformatting', timezone: detail.summary.squadTimezone, issues}, null, 2);
}
